import 'odisseia/src/step-3.css.ts.vanilla.css?source=Ll8xaHMzOWFxMCB7CiAgZGlzcGxheTogZ3JpZDsKICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDUwJSA1MCU7Cn0KLl8xaHMzOWFxMSB7CiAgbWFyZ2luLWxlZnQ6IDEuMzc1cmVtOwogIGRpc3BsYXk6IGZsZXg7Cn0KLl8xaHMzOWFxMiB7CiAgei1pbmRleDogMTI7Cn0=';
export var modalContainerImage = '_1hs39aq1';
export var modalContentStyle = '_1hs39aq0';
export var modalStyle = '_1hs39aq2';